import React from 'react';

export default class TimeButtons extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange = (event) => {
    this.props.onChange(event.target.value)
  }

  render() {
    return (
      <div className="time-buttons">
        <span className='option-title'>TIME CONTROL</span>
        <input type="radio" value={1} id="bullet" name="time" onChange={this.props.onChange} />
        <label htmlFor="bullet">1 + 1</label>
        <input type="radio" value={2} id="blitz1" name="time" onChange={this.props.onChange} />
        <label htmlFor="blitz1">3 + 2</label>
        <input type="radio" value={3} id="blitz2" name="time" onChange={this.props.onChange} />
        <label htmlFor="blitz2">5 + 3</label>
        <input type="radio" value={4} id="rapid" name="time" onChange={this.props.onChange} />
        <label htmlFor="rapid">10 + 5</label>
        <input type="radio" value={5} id="rapid2" name="time" onChange={this.props.onChange} />
        <label htmlFor="rapid2">20 + 10</label>
        <input type="radio" value={6} id="classical" name="time" onChange={this.props.onChange} />
        <label htmlFor="classical">30 + 20</label>
      </div>
    );
  }
}